import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight, Wrench } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-garage-bg" data-id="element-95">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-garage-surface via-garage-bg to-black" data-id="element-96" />
      <div className="absolute inset-0 z-0 bg-grid-pattern bg-[size:40px_40px] opacity-[0.05]" data-id="element-97" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-98">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-99">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-garage-accent/30 bg-garage-accent/10 text-garage-accent text-sm font-mono mb-6 backdrop-blur-sm" data-id="element-100">
            <Wrench className="w-4 h-4" data-id="element-101" />
            <span data-id="element-102">EST. 2024 // NO WALLS. NO RULES.</span>
          </div>

          <h1 className="text-6xl md:text-8xl lg:text-9xl font-display font-bold tracking-tighter text-garage-text mb-6" data-id="element-103">
            DEAD PEDAL
            <span className="block text-transparent bg-clip-text bg-gradient-to-b from-garage-text to-garage-muted" data-id="element-104">
              GARAGE
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-garage-muted max-w-2xl mx-auto mb-10 font-light" data-id="element-105">
            A garage without walls. A community for those who wrench, build, and
            drive.
            <span className="text-garage-accent" data-id="element-106"> Passion over polish.</span>
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-107">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-garage-accent hover:bg-garage-accent-hover text-black font-display font-bold text-lg tracking-wide uppercase rounded-sm transition-colors w-full sm:w-auto" data-id="element-108">
              Join the Community
            </motion.button>

            <motion.button whileHover={{
            scale: 1.05,
            backgroundColor: 'rgba(255,255,255,0.05)'
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 border border-garage-border text-garage-text font-display font-bold text-lg tracking-wide uppercase rounded-sm hover:border-garage-text transition-all w-full sm:w-auto flex items-center justify-center gap-2 group" data-id="element-109">
              Explore Builds
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-110" />
            </motion.button>
          </div>
        </motion.div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-garage-bg to-transparent z-10" data-id="element-111" />
    </section>;
}